import React, { useEffect, useState } from 'react'
import { company } from '../Invoice/InvoiceData';

function ActionProvider({ createChatBotMessage, setState, children }) {

    const [userData, setUserData] = useState({
        name: "",
        company: "",
        company_email: "",
        contact: "",
        email: "",
        step: null,
    });

    const updateState = (botMessage) => {
        setState((prev) => ({
            ...prev,
            messages: [...prev.messages, botMessage]
        }))
    }

    useEffect(() => {
        console.log("Data: ", userData);
    }, [userData])

    

    const handleHello = () => {
        const botMessage = createChatBotMessage("Hi there! 👋 How can I help you today?", { widget: 'smallTalk'});

        updateState(botMessage);
    }

    const handleThanks = () => {
        const botMessage = createChatBotMessage("No problem! Glad I could assist. 🤝", { widget: 'smallTalk'});

        updateState(botMessage);
    }

    

    const handleBye = () => {
        const botMessage = createChatBotMessage("See you later! Take care. 😊", { widget: 'smallTalk'});

        updateState(botMessage);
    }

    const handleDog = () => {
        const botMessage = createChatBotMessage("Here is a nice dog picture", { widget: 'dogPicture' });

        updateState(botMessage);
    }


    const handleTalk = () => {
        const botMessage = createChatBotMessage("Can I know your full name?")
        
        updateState(botMessage);

        setUserData((prev) => ({...prev, step: "askName"}));
        console.log(userData);
    }

    const handleNameInput = (name) => {
        setUserData(prev => ({...prev, name, step: "askEmail"}));

        const botMessage = createChatBotMessage(`Thanks ${name}! Could you share your email address?`);

        updateState(botMessage);
    }

    const handleEmailInput = (email) => {
        setUserData(prev => ({...prev, email, step: "askContact"}));

        const botMessage = createChatBotMessage("Got it. What’s your contact number?");
        updateState(botMessage);
    }

    const handleContactInput = (contact) => {
        setUserData(prev => ({...prev, contact, step: "askCompany"}));

        const botMessage = createChatBotMessage("And what’s your company’s name?")
        updateState(botMessage);
    }

    const handleCompanyNameInput = (company) => {
        setUserData(prev => ({...prev, company, step: "askCompanyMail"}));

        const botMessage = createChatBotMessage("Finally, could you share your company’s email address?");
        updateState(botMessage);
    }

    const completeDetails = (companyMail) => {
        setUserData(prev => ({...prev, company_email: companyMail, step: "done"}))

        const botMessage = createChatBotMessage("Thank you for providing the details. We will contact you shortly!");
        updateState(botMessage);
    }

    const handleInvalidQuery = () => {
        const botMessage = createChatBotMessage("Sorry, I didn’t get that. Can you try again?", { widget: 'smallTalk'});
        updateState(botMessage);
    }

    const handleShowMenu = () => {
        const botMessage = createChatBotMessage("Please select an option:", { widget: 'smallTalk'});
        updateState(botMessage);
    }

    const handleDashboard = () => {
        const botMessage = createChatBotMessage("Dashboard Page", { widget: 'dashboardMenuWidget'});
        updateState(botMessage)
    }

    // const handleEvents = () => {
    //     const botMessage = createChatBotMessage("Events", { widget: 'eventWidget'});
    //     updateState(botMessage);
    // }

    const handlePastEvents = () => {
        const botMessage = createChatBotMessage("Past Events", { widget: 'pastEventsWidget'});
        updateState(botMessage);
    }

    const handleCurrentEvents = () => {
        const botMessage = createChatBotMessage("Current Events", { widget: 'currentEventsWidget' });
        updateState(botMessage);
    }

    const handleMembershipDetails = () => {
        const botMessage = createChatBotMessage("Membership Details", { widget: 'membershipWidget'});
        updateState(botMessage);
    }
    
    const handleExpiryCountdown = () => {
        const botMessage = createChatBotMessage("Membership Expiry Countdown", { widget: 'countdownWidget'})
        updateState(botMessage)
    }

    const handleStatistics = () => {
        const botMessage = createChatBotMessage("Statistics Section:", { widget: 'statisticsWidget'})
        updateState(botMessage)
    }

    const handleNewsInDashboard = () => {
        const botMessage = createChatBotMessage("News Section:", { widget: 'newsWidget' });
        updateState(botMessage);
    }

    const handleNews = () => {
        const botMessage = createChatBotMessage("News>", { widget: 'newsWidget1' });
        updateState(botMessage);
    }

    const handleRecentMembers = () => {
        const botMessage = createChatBotMessage("User Profile> Recent Member", { widget: 'recentMemberWidget'});
        updateState(botMessage);
    }

    const handleMembersByCountry = () => {
        const botMessage = createChatBotMessage("Members by country section:", { widget: 'membersByCountryWidget'});
        updateState(botMessage);
    }

    const handleEvents = () => {
        const botMessage = createChatBotMessage("Events>", { widget: 'eventsWidget'});
        updateState(botMessage);
    }

    
    const handleMembership = () => {
        const botMessage = createChatBotMessage("Membership Plan", { widget: 'membershipWidget'});
        updateState(botMessage);
    }

    const handleBusinessImpact = () => {
        const botMessage = createChatBotMessage("Business Impact Menu", { widget: 'businessImpactWidget'});
        updateState(botMessage);
    }

    const handleViewImpact = () => {
        const botMessage = createChatBotMessage("Business Impact> View Impact", { widget: 'viewImpactWidget'});
        updateState(botMessage);
    }

    const handleMakeTransaction = () => {
        const botMessage = createChatBotMessage("Business Impact> Make Trasnsaction", { widget: 'makeTransactionWidget'});
        updateState(botMessage);
    }

    const handleFreightRequest = () => {
        const botMessage = createChatBotMessage("Freight Request Menu", { widget: 'freightRequestWidget' });
        updateState(botMessage)
    }

    const handleNewFreightReq = () => {
        const botMessage = createChatBotMessage("Freight Request> New Request", { widget: 'newFreightReqWidget' });
        updateState(botMessage)
    }

    const handleManageRequest = () => {
        const botMessage = createChatBotMessage("Freight Request> Request Sent | Freight Request> Request Received | Freight Request> Request Accept", { widget: 'manageReqWidget' });
        updateState(botMessage);
    }

    // User Profile parent menu
    const handleUserProfileMenu = () => {
    const botMessage = createChatBotMessage("User Profile Menu", { widget: "userProfileMenuWidget" });
    updateState(botMessage);
    };

    // My Profile
    const handleMyProfile = () => {
    const botMessage = createChatBotMessage("User Profile> User Profile", { widget: "myProfileWidget" });
    updateState(botMessage);
    };

    // User List
    const handleUserList = () => {
    const botMessage = createChatBotMessage("User Profile> User List", { widget: "userListWidget" });
    updateState(botMessage);
    };

    const handleRecentMembersInProfile = () => {
        const botMessage = createChatBotMessage("User Profile> Recent Member", { widget: "recentMembersWidget" });
        updateState(botMessage);
    };

    const handleInvoices = () => {
        const botMessage = createChatBotMessage("Invoices>", { widget: "invoicesWidget" });
        updateState(botMessage);
    };

    const handleTimeline = () => {
        const botMessage = createChatBotMessage("Timeline>", { widget: "timelineWidget" });
        updateState(botMessage);
    };

    const handleChat = () => {
        const botMessage = createChatBotMessage("Chat>", { widget: "chatWidget" });
        updateState(botMessage);
    };

    const handleHelp = () => {
        const botMessage = createChatBotMessage("Help>", { widget: "helpWidget" });
        updateState(botMessage);
    };



  return (
    <div>
      {
        React.Children.map(children, (child) => {
            return React.cloneElement(child, {
                actions: {
                    handleHello,
                    handleThanks,
                    handleHelp,
                    handleBye,                                                   
                    handleTalk,
                    handleNameInput,
                    handleEmailInput,
                    handleContactInput,
                    handleCompanyNameInput,
                    completeDetails,
                    handleInvalidQuery,
                    handleDashboard,
                    handleShowMenu,
                    handlePastEvents,
                    handleCurrentEvents,
                    handleEvents,
                    handleMembershipDetails,
                    handleExpiryCountdown,
                    handleStatistics,
                    handleNews,
                    handleRecentMembers,
                    handleMembersByCountry,
                    handleMembership,
                    handleBusinessImpact,
                    handleViewImpact,
                    handleMakeTransaction,
                    handleFreightRequest,
                    handleNewFreightReq,
                    handleManageRequest,
                    handleUserProfileMenu,
                    handleMyProfile,
                    handleUserList,
                    handleRecentMembersInProfile,
                    handleInvoices,
                    handleTimeline,
                    handleChat,
                    handleNewsInDashboard,
                    userData
                },
            })
        })
      }
    </div>
  )
}

export default ActionProvider
